<template>
  <div>
    <wc-page-title title='Invoices'>
      <template v-slot:rightSide>

        <v-tooltip top v-for='(i, index) in showHideItems' :key='index' >
          <template v-slot:activator='{ on }'>
            <v-btn v-on='on' icon @click='toggleFilter(i)'>
              <v-icon :color='i.color'>{{ i.icon }}</v-icon>
            </v-btn>
          </template>
          <span>
            {{ i.tooltipMessage }}
          </span>
        </v-tooltip>

        <wc-show-archived-button v-model='showArchived' @toggleShowArchived='showArchived = !showArchived'></wc-show-archived-button>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar
          >
            <v-data-table
              dense
              sort-by='invoice_due'
              :search='search'
              :items='filteredInvoices'
              :headers='headers'
              :items-per-page='20'
              @click:row='openInvoice'
            >
              <template v-slot:item.invoice_date='{ item }'>
                {{ item.invoice_date | shortDate }}
              </template>
              <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <wc-archived v-if='item.archived'></wc-archived>
              </template>
              <template v-slot:item.status='{ item }'>
                <status-chip :invoice='item' small></status-chip>
              </template>
              <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import StatusChip from '@/modules/accounting/components/invoice/StatusChip';
import _ from 'lodash';

export default {
  name: 'invoices',
  data: () => ({
    isLoading: true,
    search: '',
    invoices: [],
    showUnsent: true,
    showUnpaid: true,
    showPaid: false,
    showOverdue: true,
    showArchived: false,
    headers: [
      { text: 'Invoice Date', value: 'invoice_date' },
      { text: 'Inv #', value: 'number' },
      { text: 'Bill to', value: 'bill_to_display' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Amount OS', value: 'amount_os', align: 'right' }
    ]
  }),
  computed: {
    showHideItems () {
      return [
        {
          text: 'Unpaid',
          icon: 'mdi-alert-circle-outline',
          color: this.showUnpaid ? 'warning' : 'grey lighten-2',
          tooltipMessage: this.showUnpaid ? 'Hide Unpaid' : 'Show Unpaid'
        },
        {
          text: 'Overdue',
          icon: 'mdi-alert',
          color: this.showOverdue ? 'error' : 'grey lighten-2',
          tooltipMessage: this.showOverdue ? 'Hide Overdue' : 'Show Overdue'
        },
        {
          text: 'Unsent',
          icon: 'mdi-send',
          color: this.showUnsent ? 'info' : 'grey lighten-2',
          tooltipMessage: this.showUnsent ? 'Hide Unsent' : 'Show Unsent'
        },
        {
          text: 'Paid',
          icon: 'mdi-checkbox-marked-circle-outline',
          color: this.showPaid ? 'success' : 'grey lighten-2',
          tooltipMessage: this.showPaid ? 'Hide Paid' : 'Show Paid'
        }
      ]
    },
    onlyArchived () {
      return this.invoices.filter(i => { return i.archived })
    },
    onlyNONArchived () {
      return this.invoices.filter(i => { return !i.archived })
    },
    filteredInvoices () {
      let invs = []
      invs = this.showUnsent ? invs.concat(this.onlyNONArchived.filter(i => { return i.status === 'unsent' })) : invs
      invs = this.showUnpaid ? invs.concat(this.onlyNONArchived.filter(i => { return i.status === 'unpaid' })) : invs
      invs = this.showPaid ? invs.concat(this.onlyNONArchived.filter(i => { return i.status === 'paid' })) : invs
      invs = this.showOverdue ? invs.concat(this.onlyNONArchived.filter(i => { return i.status === 'overdue' })) : invs
      invs = this.showArchived ? invs.concat(this.onlyArchived) : invs
      return invs
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
        console.log("get")
      this.isLoading = true
      this.invoices = _.orderBy(await accountingAPI.getInvoices(), 'invoice_date')
      this.isLoading = false
    },
    openInvoice (item) {
      this.$router.push({ name: 'InvoiceOverview', params: { id: item.id } })
    },
    toggleFilter (filter) {
      switch (filter.text) {
        case 'Unpaid':
          this.showUnpaid = !this.showUnpaid
          break
        case 'Unsent':
          this.showUnsent = !this.showUnsent
          break
        case 'Overdue':
          this.showOverdue = !this.showOverdue
          break
        case 'Paid':
          this.showPaid = !this.showPaid
          break
      }
    }
  },
  components: {
    'status-chip': StatusChip
  }
}
</script>
